const colBoard = ["热门瓜料", "娱乐八卦", "科技热评", "生活段子", "游戏吃瓜"];
const colHelp = ["社区公约", "常见问题", "举报反馈", "新瓜友指南", "帮助中心"];
const colAbout = ["关于我们", "内容原则", "加入我们", "联系小编", "媒体报道"];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14 w-full">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2">
            <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
              <span className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-group-line" aria-hidden="true"></i>
              </span>
              <span className="font-logo text-2xl text-primary-600 leading-none">
                吃瓜<span className="text-foreground-950">17</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xs">
              吃瓜17社区，一个认真围观、友善开麦的论坛讨论区。每天为你精选热门话题与群聊精华。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-chat-smile-line", label: "即时交流" },
                { icon: "ri-quill-pen-line", label: "投稿" },
                { icon: "ri-mail-send-line", label: "邮件联系" },
                { icon: "ri-global-line", label: "社区官网" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href="#about"
                  aria-label={s.label}
                  className="w-9 h-9 rounded-full bg-background-50 border border-secondary-200 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors"
                >
                  <i className={s.icon} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {[
            { title: "热门板块", links: colBoard, href: "#board" },
            { title: "帮助支持", links: colHelp, href: "#faq" },
            { title: "关于我们", links: colAbout, href: "#about" },
          ].map((c) => (
            <nav key={c.title} aria-label={c.title}>
              <h4 className="text-sm font-bold text-foreground-950">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href={c.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2021-2026 吃瓜17社区 chigua17.com · 保持理性，友善开麦</p>
          <a
            href="mailto:hello@chigua17.com"
            className="inline-flex items-center gap-2 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-line" aria-hidden="true"></i> hello@chigua17.com
          </a>
        </div>
      </div>
    </footer>
  );
}